module.exports = __webpack_public_path__ + "img/linux.fbfd724.png";